import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import SydButton from '../../../../commonDesign/Button'
import { useAppContext } from '../../../../../redux/slices/appContext'
import { postNamedQuery } from '../../../../../service'
import { ICON_NAMES } from '../../../../../constants'

export const DownloadOrionDocumentCell = ({ cell }) => {
  const { row, column } = cell
  const value = row?.original?.id
  const { contentDisposition = 'attachment', label = 'Download', icon = ICON_NAMES.download } = column.data ?? {}
  const { clientId } = useAppContext()

  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const handleClick = useCallback(async () => {
    setIsLoading(true)
    try {
      const response = await postNamedQuery('vaultV2', 'get-orion-client-document-download', {
        clientId: clientId,
        fileId: value,
        contentDisposition: contentDisposition
      })

      window.open(response.data.signedUrl, '_blank')
    } catch (err) {
      setIsError(true)
      setTimeout(() => {
        setIsError(false)
      }, 3000)
    } finally {
      setIsLoading(false)
    }
  }, [clientId, contentDisposition, value])

  if (!value) return null

  return (
    <SydButton
      size='sm'
      variant='primary'
      priority={isError ? 'warning' : 'main'}
      icon={isError ? 'warning' : icon}
      processing={isLoading}
      onClick={handleClick}
      disabled={isLoading}
    >
      {isError ? 'Error getting file' : label}
    </SydButton>
  )
}
DownloadOrionDocumentCell.propTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.string
      })
    }),
    column: PropTypes.shape({
      data: PropTypes.shape({
        contentDisposition: PropTypes.string,
        label: PropTypes.string,
        icon: PropTypes.string
      })
    })
  }).isRequired
}
